<template>
    <div class="login-wrapper">
     <div class="background-image"></div>
  
      <div class="content">
        <div class="logo-wrapper">
          <img src="@/assets/logo_2025.png" alt="Logo" class="login-logo" />
        </div>
  
        <div class="login-container">
          <h2>Operator Login</h2>
          <form @submit.prevent="handleLogin">
            <div>
              <label for="username">Username:</label>
              <input type="text" id="username" v-model="username" required />
            </div>
            <div>
              <label for="password">Password:</label>
              <input type="password" id="password" v-model="password" required />
            </div>
            <button type="submit">Login</button>
            <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref } from 'vue'
  import axios from 'axios'
  import { useRouter } from 'vue-router'
  
  const username = ref('')
  const password = ref('')
  const errorMessage = ref('')
  const router = useRouter()
  
  const handleLogin = async () => {
    let response = null
    try {
      response = await axios.post('https://app.streamboxtv.live/api3002/api/login', {
        username: username.value,
        password: password.value
      })
  
      const token = response.data?.token
      if (token) {
        localStorage.setItem('adminToken', token)
        localStorage.setItem('userData', JSON.stringify(response.data.operater))
        router.push('/admin/manage')
      } else {
        errorMessage.value = 'Token is undefined'
      }
    } catch (err) {
      errorMessage.value = err.response?.data?.message || 'Error on login'
    }
  }
  </script>
  
  <style scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
  
}
.login-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;

}


  

  h2 {
    text-align: center;
    color: #00bfff;
    margin-bottom: 1em;
  }
  
  label {
    display: block;
    margin-bottom: 8px;

    color: black;
  }
  
  input[type='text'],
  input[type='password'] {
    width: 100%;
    padding: 12px;
    margin-bottom: 20px;
    border: none;
    border-radius: 8px;
    background-color: rgba(228, 232, 235);
    color: black;
    font-size: 16px;
    transition: background-color 0.1s;
  }
  
  input:focus {
    background-color: silver;
 color:black;
  }
  
  button[type='submit'] {
    width: 100%;
    padding: 12px;
    background-color: #00bfff;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.1s, transform 0.1s;
  }
  
  button[type='submit']:active {
    transform: scale(0.98);
  }
  
  .error {
    margin-top: 1em;
    color: #ff4d4d;
    text-align: center;
    font-weight: bold;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgb(180, 188, 194);
  background-size: cover;
  filter: brightness(0.6);
  z-index: 0;
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo-wrapper {
  margin: 70px 0;

  text-align: center;
}

.login-logo {
  max-width: 220px;

}
.login-container {
  background-color: white;
  padding: 2em;
  border-radius: 5px;
  box-shadow:1px 1px 150px rgba(1,1,1,0.2);
 color: #fff;
  margin-top:100px;
  width: 800px;
  animation: fadeIn 0.2s ease;
  
}
@media (max-width: 800px) {
  .login-container {
   width: 300px;
    padding: 1.2em;
  }
}

  </style>
  